require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

module.exports = function (e) {
  var t = {};

  function r(l) {
    if (t[l]) return t[l].exports;
    var a = t[l] = {
      i: l,
      l: !1,
      exports: {}
    };
    return e[l].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, l) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: l
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var l = Object.create(null);
    if (r.r(l), Object.defineProperty(l, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) {
      r.d(l, a, function (t) {
        return e[t];
      }.bind(null, a));
    }
    return l;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Header = t.GetThis = t.Footer = t.Hero = void 0;
  var l = u(r(2)),
      a = u(r(3)),
      n = u(r(4)),
      o = u(r(5));

  function u(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  t.Hero = l["default"], t.Footer = a["default"], t.GetThis = n["default"], t.Header = o["default"];
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var l,
      a = r(0),
      n = (l = a) && l.__esModule ? l : {
    "default": l
  };

  t["default"] = function (e) {
    var t = e.title,
        r = e.places;
    return n["default"].createElement("div", {
      className: "row container-small pad-20-t pad-20-b"
    }, n["default"].createElement("div", {
      className: "col-xs-12 col-md-6 pad-10-l"
    }, n["default"].createElement("h1", {
      className: "is-hero-menu margin-0 is-white"
    }, t), n["default"].createElement("div", {
      className: "border"
    }), n["default"].createElement("h4", {
      className: "is-hero-sub-text"
    }, "A", r.map(function (e, t) {
      return n["default"].createElement(a.Fragment, null, n["default"].createElement("a", {
        href: e.url,
        target: "_blank",
        className: "link-reverse",
        rel: "noopener noreferrer",
        key: e.label
      }, (0 === t ? " " : "") + e.label), r.length !== t + 1 ? "/" : " ");
    }), "boilerplate.")));
  };
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var l,
      a = r(0),
      n = (l = a) && l.__esModule ? l : {
    "default": l
  };

  t["default"] = function () {
    return n["default"].createElement("footer", {
      className: "is-white-bg is-grey margin-2 footer"
    }, "Boilerplate made with", " ", n["default"].createElement("span", {
      role: "img",
      "aria-label": "love"
    }, "❤️"), " ", "by", " ", n["default"].createElement("a", {
      href: "https://sld.codes",
      target: "_blank",
      rel: "noopener noreferrer",
      className: "link"
    }, "sld.codes"), ". Happy Hacking.", n["default"].createElement("a", {
      className: "link is-pink",
      href: "https://www.buymeacoffee.com/lLj8yvRAk",
      target: "_blank",
      rel: "noopener noreferrer"
    }, n["default"].createElement("p", null, "Buy me a coffee ☕️.")));
  };
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var l,
      a = r(0),
      n = (l = a) && l.__esModule ? l : {
    "default": l
  };

  t["default"] = function (e) {
    var t = e.flag;
    return n["default"].createElement("div", {
      className: "row container-small pad-10-t pad-10-b pad-10-l is-grey"
    }, n["default"].createElement("div", {
      className: "col-xs-12"
    }, n["default"].createElement("h1", {
      className: "is-hero-sub-menu margin-0"
    }, "Get this boilerplate"), n["default"].createElement("h4", null, "You’ll need to have Node 8.16.0 or Node 10.16.0 or later version on your local development machine ."), n["default"].createElement("h4", null, "If you've got that, great! Simply open a terminal and enter:"), n["default"].createElement("code", {
      className: "pad-3 is-grey-bg is-white border-radius"
    }, "npx -p yo -p generator-sld -- yo sld:" + t), n["default"].createElement("h4", null, "Not the boilerplate for you?", " ", n["default"].createElement("a", {
      href: "https://boilerplates.sld.codes",
      target: "_blank",
      className: "link"
    }, "Click here to see my other boilerplates."))));
  };
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var l,
      a = r(0),
      n = (l = a) && l.__esModule ? l : {
    "default": l
  };

  t["default"] = function (e) {
    var t = e.logo;
    return n["default"].createElement("div", {
      className: "is-white-bg margin-5"
    }, n["default"].createElement("div", {
      className: "row flex padding-0-tb container-small"
    }, n["default"].createElement("div", {
      className: "col-xs-9 flex"
    }, n["default"].createElement("img", {
      src: t,
      className: "logo"
    }))));
  };
}]);